<!-- Back to top button -->
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css">
<link href="https://fonts.googleapis.com/css?family=Merriweather:400,900,900i" rel="stylesheet">
<a *ngIf="isShow" id="button" (click)="gotoTop()"></a>

<button *ngIf="isShow" onclick="topFunction()" id="myBtn" title="Go to top">Top</button>


<router-outlet></router-outlet>



<!--
<div>


    <label class="form-inline">
      <select class="form-control" #selectedLang (change)="switchLang(this.url)">
        <option *ngFor="let language of translate.getLangs()" [value]="language"  [selected]="language === translate.currentLang">
{{language}}
        </option>
      </select>
    </label>

</div>
-->
